import { GET } from "../service/axiosMethods"

export const getSecrets = async () =>{
    const response = await GET(`secrets/sendSecretsToClient`)
    if(response && response.data && response.data.secrets){
        Object.keys(response.data.secrets).forEach(key => {
            window[key] = response.data.secrets[key]
        });
    }   

}